module.exports = __webpack_public_path__ + "static/media/resume.5284ba67.pdf";